/* regions */
export const GET_REGIONS_REQUEST = 'resources/regions/GET_REGIONS_REQUEST'
export const GET_REGIONS_SUCCESS = 'resources/regions/GET_REGIONS_SUCCESS'
export const GET_REGIONS_ERROR = 'resources/regions/GET_REGIONS_ERROR'

export const FETCH_REGION_REQUEST = 'resources/regions/FETCH_REGION_REQUEST'
export const FETCH_REGION_SUCCESS = 'resources/regions/FETCH_REGION_SUCCESS'
export const FETCH_REGION_FAILURE = 'resources/regions/FETCH_REGION_FAILURE'
